
import { EntityType, CtaTarget } from '@shared/types/mylounge';
import { Config } from '@shared/types/config';

import {
    CATALOG_ROUTE,
    MYLOUNGE_ROUTE,
    FALLBACK_ROUTE,
    ERROR_INVALID_CATEGORIES,
    ERROR_WRONG_CAMPAIGNID
} from '@client/config/constants';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';

export const getImageUrl = (config: Config, type?: string, image?: string) => {
    if (!image) {
        return '';
    }

    return type ? `${config.getUrl('articles', true)}${type}/${image}`
        : `${config.getUrl('articles', true)}${image}`;
}

export const getVideoUrl = (config: Config, video?: string) =>
    video ? `${config.getUrl('articlesVideos')}/${video}` : '';

export const createCookie = (
    name: string,
    value: string,
    expires: string | Date,
    path: string,
    domain: string | number
) => {
    var cookie = `${name} = ${escape(value)};`;

    if (expires) {
        // If it's a date
        if (expires instanceof Date) {
            // If it isn't a valid date
            if (isNaN(expires.getTime())) {
                expires = new Date();
            }
        }
        else {
            expires = new Date(new Date().getTime() + parseInt(expires) * 1000 * 60 * 60 * 24);
        }
        cookie += `expires= ${expires.toUTCString()};`;
    }

    if (path) {
        cookie += `path= ${path};`;
    }
    if (domain) {
        cookie += `domain= ${domain};`;
    }

    document.cookie = cookie;
}

export const getCookie = (name: string): string => {
    if (typeof window !== 'undefined') {
        const arrayCookie = document.cookie.split('; ');
        for (let i = 0; i < arrayCookie.length; i++) {
            const element = arrayCookie[i].split('=');
            if (name === element[0]) {
                return unescape(element[1]);
            }
        }
    }

    return undefined;
}

// TODO: clean it up with new myLounge API
export const buildUrlForEntity = ({
    entityType,
    entityId,
    url
}: CtaTarget): string | null => {
    switch (entityType) {
        case EntityType.EVENT:
            return buildCampaignUrl(entityId);
        case EntityType.LINK:
            return url;
        case EntityType.CATEGORY_TAB:
            return `/event/${entityId}${window.location.search}`;
        default:
            return null;
    }
}

// TODO: clean up the error object
interface LoadingError {
    error: {
        fallbackCampaign?: {
            campaignIdentifier: string;
        },
        campaignIdentifier: string;
        code: string;
    }
}

interface CurrentLocation {
    search?: string;
}

export const buildUrlForRouteLoadingError = (
    loadingError: LoadingError | null = null,
    currentLocation: CurrentLocation = null
) => {

    // react-router 'search' key it has '?' inside the string.
    const searchQueryParams = ((currentLocation && currentLocation.search) || '');

    if (loadingError && loadingError.error) {

        if (loadingError.error.fallbackCampaign) {
            return `${CATALOG_ROUTE}/${loadingError.error.fallbackCampaign.campaignIdentifier}${searchQueryParams}`;
        }

        switch (loadingError.error.code) {
            case ERROR_INVALID_CATEGORIES:
                return `${CATALOG_ROUTE}/${loadingError.error.campaignIdentifier}${searchQueryParams}`;
            case ERROR_WRONG_CAMPAIGNID:
                return `${MYLOUNGE_ROUTE}${searchQueryParams}`;
            default:
                if (loadingError.error.campaignIdentifier) {
                    return `${MYLOUNGE_ROUTE}?event=${loadingError.error.campaignIdentifier}&status=upcoming${searchQueryParams.replace('?', '&')}`;
                }
        }

    }

    return `${FALLBACK_ROUTE}${searchQueryParams}`;
}
